
import { error } from "@/services/LoggerService";
import Vue from "vue";
import { useStore } from "@/store";
import { AuthActionTypes } from "@/store/auth/actions";

export default Vue.extend({
  name: "ResetPassword",
  data() {
    return {
      email: "",
      code: "",
      password: "",
      confirmPassword: "",
      resettingPassword: "off",
    };
  },
  methods: {
    async resetPassword() {
      try {
        this.resettingPassword = "on";
        await this.completeResetPassword(this.email, this.code, this.password);
        this.resettingPassword = "off";
        this.$router.push({ name: "Login" });
      } catch (e) {
        this.resettingPassword = "off";
        alert(e);
        error(e);
      }
    },
    async completeResetPassword(
      email: string,
      code: string,
      newPassword: string
    ): Promise<void> {
      return useStore().dispatch(AuthActionTypes.ResetPassword, {
        email,
        code,
        password: newPassword,
      });
    },
  },
  beforeMount() {
    this.code = this.$route.params.code;
  },
});
